import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import { endSession, signOut } from "../../api/session";
import { SignOutIcon } from "../icons";
import { IconButton } from "../ui/button";

export function SignOutButton() {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationFn: signOut,
		// Signed out on this device whatever the answer: the API clears the cookies even without a valid session.
		onSettled: async () => {
			endSession(queryClient);
			await navigate({ to: "/login" });
		},
	});

	return (
		<IconButton
			aria-label="Sign out"
			disabled={mutation.isPending}
			onClick={() => {
				mutation.mutate();
			}}
		>
			<SignOutIcon />
		</IconButton>
	);
}
